import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const SortFilter = ({ value, onChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel>Sort By</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label="Sort By"
      >
        <MenuItem value="relevance">Relevance</MenuItem>
        <MenuItem value="year">Year (Newest First)</MenuItem>
        <MenuItem value="citations">Citations (Most First)</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SortFilter; 